var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',[_c('AppBar',{staticStyle:{"height":"30px","padding":"0"}},[_c('AppTitle2',{attrs:{"name":"用户中心","icon":"md-person"}}),(_vm.menus.length > 1)?_c('AppMenu2',{attrs:{"menus":_vm.menus}}):_vm._e(),_c('div')],1),_c('AppClient',{attrs:{"top":30}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }